import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';


import * as _ from 'lodash';

import { AuthService } from '../auth/auth.service';
import { BrandService } from '../brand/brand.service';
import { SessionService } from '../session/session.service';
import {of} from 'rxjs/internal/observable/of';


@Injectable()
export class BaseHttpService {

  constructor(
    protected http: HttpClient,
    protected authService: AuthService,
    protected brandService: BrandService,
    protected sessionService: SessionService
  ) {}

  protected handleError(err: any) {
    let errMessage: string;

    if (err instanceof HttpErrorResponse) {
        const body: any = err || '';
        const error = body.error || JSON.stringify(body);

        if (error === 'token_invalid' || error === 'user_not_found' || err.status === 401) {
            this.authService.logout();
        }

        errMessage = `${err.status} - ${err.statusText} || ''} ${error}`;
    } else {
        errMessage = err.message ? err.message : err.toString();
        if (errMessage === 'No JWT present or has expired') {
          this.authService.logout();
        }
    }

    console.log('error', errMessage);
    return of(errMessage);
  }

  /*
    * DELETE with body
  */
  protected delete(url: string, body: any, options: any) {
    // let requestOptions = new RequestOptions({url, body, method: RequestMethod.Delete});
    // if (options) {
    //   requestOptions = requestOptions.merge(options);
    // }
    return this.http.request(
      'delete',
      url,
      _.assign({}, options, { body })
     );
  }
}
